import React from 'react';
import { FileText } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="bg-gradient-to-b from-black via-gray-900 to-black py-20 px-4">
        <div className="container mx-auto text-center">
          <FileText className="mx-auto text-yellow-400 mb-6" size={64} />
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6">
            Terms of Service
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Last updated: January 2025
          </p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-black mb-6">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [This is placeholder text for the Terms of Service. The actual terms will be added by bHyyve legal team. 
              This document will govern the use of bHyyve's platform and services, establishing the legal relationship 
              between users and bHyyve Inc.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">2. Description of Service</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will describe bHyyve's marketplace platform that connects users with 
              service providers, including booking features, payment processing, and customer support.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">3. User Accounts</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will outline requirements for creating and maintaining user accounts, 
              including age restrictions, account security responsibilities, and prohibited activities.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">4. User Conduct and Responsibilities</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will define acceptable use policies, prohibited activities, and user 
              obligations when using the platform.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">5. Service Provider Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will outline specific terms for service providers, including verification 
              requirements, service standards, and commission structure.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">6. Bookings and Payments</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will detail the booking process, payment terms, cancellation policies, 
              refund procedures, and dispute resolution.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">7. Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will address ownership of platform content, trademarks, user-generated 
              content, and license grants.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">8. Disclaimers and Limitations of Liability</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will outline bHyyve's liability limitations, service disclaimers, and 
              indemnification provisions.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">9. Termination</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will describe conditions under which accounts may be terminated or 
              suspended, and the effects of termination.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">10. Dispute Resolution</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will outline procedures for resolving disputes, including arbitration 
              clauses and governing law (Ontario, Canada).]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">11. Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will explain how users will be notified of changes to the terms and 
              when modifications become effective.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">12. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              If you have questions about these Terms of Service, please contact us at:
            </p>
            <div className="bg-gray-50 border-2 border-gray-200 rounded-xl p-6 mb-8">
              <p className="text-gray-700 mb-2"><strong>Email:</strong> legal@bhyyve.com</p>
              <p className="text-gray-700 mb-2"><strong>Mail:</strong> bHyyve Inc., 123 Service Street, Toronto, ON M5V 1A1</p>
              <p className="text-gray-700"><strong>Phone:</strong> +1 (555) 000-0000</p>
            </div>

            <div className="bg-yellow-400/20 border-2 border-yellow-400 rounded-xl p-6">
              <p className="text-black font-semibold">
                <strong>Note:</strong> This is a placeholder document. The final terms of service will be drafted by legal 
                counsel to ensure full compliance with Ontario and Canadian laws and to adequately protect bHyyve's interests 
                while being fair to users.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;